import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { LessonCard } from "./../../Models/lessons.interface";
import { ScrollService } from "../../Services/ScrollManager/scroll.service";
import {
  trigger,
  state,
  transition,
  animate,
  style,
} from "@angular/animations";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { Subject } from "rxjs";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
@Component({
  selector: "app-my-lessons",
  templateUrl: "./my-lessons.component.html",
  styleUrls: ["./my-lessons.component.css"],
  animations: [
    trigger("title", [
      state("void", style({ opacity: 0 })),
      state("show", style({ opacity: 1 })),
      transition("void => *", [animate("400ms ease-in-out")]),
      transition("* => void", [animate("400ms ease-in-out")]),
    ]),
  ],
})
export class MyLessonsComponent implements OnInit, OnDestroy {
  choosenLessonCard: LessonCard;
  @Input() authLevel;
  config;
  currentState = "show";
  leaving = new Subject();
  profile;
  constructor(
    private um: UserManager,
    private scroll: ScrollService,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        console.log(config.lessonsCards[0]);
        this.config = config;
      },
    });
    this.um
      .getProfileSubject()
      .takeUntil(this.leaving)
      .subscribe((profile) => (this.profile = profile));
  }

  register() {
    this.um.openSignUp();
  }

  ngOnDestroy() {}
  ngOnInit() {
    this.scroll.scrollToElement("#logo");
  }
  ngAfterViewInit() {}

  toggleLessonHeaderBar(lessonCard: LessonCard) {
    this.choosenLessonCard = lessonCard;
  }

  sendTitleOut() {
    this.currentState = "void";
  }
}
